// extracted by mini-css-extract-plugin
export default {"container":"Fea-z","productName":"Gea-z","price":"Hea-z","dimensions":"Iea-z"};